import useDiscoveryFetch from './useDiscoveryFetch';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import api from '../../api/axiosInstance';
import { useParams } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    Image,
    Spinner,
    Alert,
} from 'react-bootstrap';
import Sidebar from '../../Sidebar';
import Breadcrumb from '../../Breadcrumb';
import icQ from '../../assets/img/ic-q.svg';
import icA from '../../assets/img/ic-a.svg';
import NavTabs from '../../NavTabs';
import CountryDetailHero from './countryDetail/CountryDetailHero';
import CountryDetailMobileTabs from './countryDetail/CountryDetailMobileTabs';
import getCountryDetailNavItems from './countryDetail/countryDetailNavItems';
import { useMobileAiPageContext } from '../../MobileAiAssistantContext';
import { getDiscoveryAiSuggestions } from '../../utils/discoveryAiSuggestions';

const DiscoveryCountryViewWorkTax = () => {
    const { id } = useParams();
    const isMobile = useMediaQuery({ query: '(max-width: 991.98px)' });

    const [countryData, setCountryData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useDiscoveryFetch(({ signal, isCurrent, isReconnect }) => {
        const fetchCountry = async () => {
            try {
                if (!isReconnect || !countryData) setLoading(true);
                setError('');
                const response = await api.get(`/api/discovery/countries/${id}`, { signal });
                if (!isCurrent()) return;
                setCountryData(response.data);
            } catch (err) {
                if (!isCurrent()) return;
                console.error('Error fetching country:', err);
                setError('An error occurred while fetching country details.');
            } finally {
                if (!isCurrent()) return;
                setLoading(false);
            }
        };

        fetchCountry();
    }, [id]);

    const formData = {
        countryName: countryData?.countryName || countryData?.country?.name || '',
        url: countryData?.url || '',
        cityCount: countryData?.cityCount || 0,
        weekWorkingHours: countryData?.weekWorkingHours || '',
        wageAmount: countryData?.wageAmount || '',
        internshipsRegulation: countryData?.internshipsRegulation || '',
        incomeTaxLiability: countryData?.incomeTaxLiability || '',
        doubleTaxationAgreementUrl: countryData?.doubleTaxationAgreementUrl || '',
        healthInsurance: countryData?.healthInsurance === true || countryData?.healthInsurance === 'true' ? 'Yes' : countryData?.healthInsurance === false || countryData?.healthInsurance === 'false' ? 'No' : countryData?.healthInsurance || '',
        accidentInsurance: countryData?.accidentInsurance === true || countryData?.accidentInsurance === 'true' ? 'Yes' : countryData?.accidentInsurance === false || countryData?.accidentInsurance === 'false' ? 'No' : countryData?.accidentInsurance || '',
    };

    const discoveryCountryNavItems = getCountryDetailNavItems(id);

    // Opt this page into the shared mobile AI assistant (header trigger + bottom sheet).
    useMobileAiPageContext({
        pageType: 'discovery-country',
        discoveryType: 'countries',
        countryId: id,
        countryName: countryData?.countryName || countryData?.country?.name || '',
        activeTab: 'Work & Tax',
        suggestions: getDiscoveryAiSuggestions({
            discoveryType: 'countries',
            selectedCountry: countryData?.countryName || countryData?.country?.name || '',
        }),
    });

    if (loading) {
        return (
            <>
                <Sidebar />
                <main className="main-content flex-grow-1">
                    <Container>
                        <Row>
                            <Col className="py-5 text-center">
                                <Spinner animation="border" />
                            </Col>
                        </Row>
                    </Container>
                </main>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Sidebar />
                <main className="main-content flex-grow-1">
                    <Container>
                        <Row>
                            <Col>
                                <Alert variant="danger" className="mt-4">{error}</Alert>
                            </Col>
                        </Row>
                    </Container>
                </main>
            </>
        );
    }

    if (!countryData) {
        return (
            <>
                <Sidebar />
                <main className="main-content flex-grow-1">
                    <Container>
                        <Row>
                            <Col>
                                <Alert variant="warning" className="mt-4">Country not found.</Alert>
                            </Col>
                        </Row>
                    </Container>
                </main>
            </>
        );
    }

    const sectionContent = (
        <>
            <Row className={isMobile ? undefined : 'mb-4'}>
                <Col>
                    <Card className="h-100">
                        <Card.Body className={isMobile ? 'pb-0' : undefined}>
                            <Row>
                                <Col md={12}>
                                    <h3><span className="item-number">4.</span> Work & Tax</h3>
                                    <hr />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="How many hours per week?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        How many hours per week are considered regular working hours? (regular is not the legal maximum)
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="How many hours per week?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                <strong>{formData.weekWorkingHours || 'N/A'}</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>

                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="Is there a statutory minimum wage?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        Is there a statutory minimum wage and, if so, how high is it?
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="Is there a statutory minimum wage?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                <strong>{formData.wageAmount || 'N/A'}</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="How is internship payment regulated?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        How is the payment of internships regulated by law?
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="How is internship payment regulated?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                <strong>{formData.internshipsRegulation || 'N/A'}</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>

                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="What income tax liability for foreigners?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        What income tax liability exists for foreigners in the destination country?
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="What income tax liability for foreigners?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                <strong>{formData.incomeTaxLiability || 'N/A'}</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="Which countries have double taxation agreements in place?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        Which countries have double taxation agreements in place?
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="Which countries have double taxation agreements in place?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                {formData.doubleTaxationAgreementUrl ? (
                                                                                                    <a
                                                                                                        href={formData.doubleTaxationAgreementUrl.startsWith('http') ? formData.doubleTaxationAgreementUrl : `https://${formData.doubleTaxationAgreementUrl}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        className="fw-bold"
                                                                                                    >
                                                                                                        Read source
                                                                                                    </a>
                                                                                                ) : (
                                                                                                    <strong>N/A</strong>
                                                                                                )}
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>

                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="Is health insurance compulsory?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        Is health insurance compulsory?
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="Is health insurance compulsory?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                <strong>{formData.healthInsurance || 'N/A'}</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>

                                                                <Row className={isMobile ? undefined : 'mb-3'}>
                                                                    <Col md={6}>
                                                                        <Card>
                                                                            <Card.Body className="p-3">
                                                                                <div className="icon-text align-items-center">
                                                                                    <span className="icon" aria-hidden="true">
                                                                                        <Image src={icQ} alt="Is accident insurance obligatory?" />
                                                                                    </span>
                                                                                    <span className="text">
                                                                                        Is there an obligation to have accident insurance for employees?
                                                                                    </span>
                                                                                </div>
                                                                            </Card.Body>
                                                                        </Card>
                                                                        <Row className="sub-card-row">
                                                                            <Col className="justify-content-start">
                                                                                <Card>
                                                                                    <Card.Body>
                                                                                        <div className="icon-text align-items-center">
                                                                                            <span className="icon" aria-hidden="true">
                                                                                                <Image src={icA} alt="Is accident insurance obligatory?" />
                                                                                            </span>
                                                                                            <span className="text">
                                                                                                <strong>{formData.accidentInsurance || 'N/A'}</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                    </Card.Body>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

    return (
        <>
            <Sidebar />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            <Breadcrumb countryName={formData.countryName} subPage="Work & Tax" />
                        </Col>
                    </Row>

                    {!isMobile ? (
                        <Row>
                            <Col>
                                <Card className="mb-4">
                                    <Card.Body className="pt-0">
                                        <Row>
                                            <Col xs={12}>
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <Card className="card-premium">
                                                                <Card.Body>
                                                                    <Row className="align-items-center">
                                                                        <Col>
                                                                            <h3 className="text-start">Country</h3>
                                                                            <hr />
                                                                        </Col>
                                                                    </Row>

                                                                    <Row className="mb-4">
                                                                        <Col md={8} className="d-flex">
                                                                            <div>
                                                                                <h1>{formData.countryName || '—'}</h1>
                                                                                <p>
                                                                                    {formData.url ? (
                                                                                        <a
                                                                                            href={formData.url.startsWith('http') ? formData.url : `https://${formData.url}`}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                        >
                                                                                            {formData.url}
                                                                                        </a>
                                                                                    ) : '—'}
                                                                                    {formData.cityCount > 0 && (
                                                                                        <>
                                                                                            <span className="dot"></span>
                                                                                            Live cities: <strong>{formData.cityCount}</strong>
                                                                                        </>
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-5">
                                                        <Col>
                                                            <NavTabs items={discoveryCountryNavItems} />
                                                        </Col>
                                                    </Row>

                                                    {sectionContent}
                                                </>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        <div className="country-detail-mobile country-detail-mobile--work-tax">
                            <CountryDetailHero
                                countryName={formData.countryName}
                                url={formData.url}
                                cityCount={formData.cityCount}
                            />

                            <CountryDetailMobileTabs items={discoveryCountryNavItems} />

                            <Card className="country-detail-content-card mb-4">
                                <Card.Body>
                                    {sectionContent}
                                </Card.Body>
                            </Card>
                        </div>
                    )}
                </Container>
            </main>
        </>
    );
};

export default DiscoveryCountryViewWorkTax;
